module.exports = __webpack_public_path__ + "img/logo.e5290b15.png";